module.exports = __webpack_public_path__ + "static/img/toin.7b876a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toin.svg
// module id = SbHO
// module chunks = 0